/**
 * PRODUCT GRID COMPONENT
 * 
 * Grid display of products with selection handling
 */

import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products = [], selectedId, onSelect, markup = 20 }) => {
  if (products.length === 0) {
    return (
      <div className="empty-state" style={{ padding: '3rem' }}>
        <p>No products found for this category.</p>
      </div>
    );
  }
  
  return (
    <div className="product-grid">
      {products.map(product => (
        <ProductCard
          key={product.product_id}
          product={product}
          isSelected={selectedId === product.product_id}
          onSelect={() => onSelect(product)}
          markup={markup}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
